export default __webpack_public_path__ + "static/media/-511636298414249882logo_black_bold_eng.a68329c7.svg";